export default __webpack_public_path__ + "static/media/AcOffMode.9feb978d.svg";